(function(){
     'use strict';

     angular
        .module('appback')
        .factory('AgenciasService', AgenciasService);

    AgenciasService.$inject = ['$http'];

    function AgenciasService($http){
        var service= {
           getAgencias:getAgencias,
           guardar:guardar,
        };

        return service;
        function getAgencias(callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/agenciatransporte/getagencias', { params : { }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function guardar(agencias,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

           	var agenciasSimplify = [];
           	for(var cont=0;cont<agencias.length;cont++){
           		agenciasSimplify.push({"id":agencias[cont].id,"horario":agencias[cont].horario});
           	}

            var data = $.param({ 
                agencias:JSON.stringify(agenciasSimplify), 
            });
            $http.post('/backend/agenciatransporte/guardar',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }
    }
})();